<div class="review-dialog">
    <div class="dialog-header one-row">
        <h2>{{ data.mode === 'edit' ? 'Gutschrift bearbeiten' : 'Gutschrift abgleichen' }}</h2>
        <span class="spacer"></span>
        <button mat-icon-button type="button" (click)="prevPage()" [disabled]="page <= 1" matTooltip="Vorherige Seite">
            <mat-icon>navigate_before</mat-icon>
        </button>
        <span class="page-label">{{ page }} / {{ totalPages || '…' }}</span>
        <button
            mat-icon-button
            type="button"
            (click)="nextPage()"
            [disabled]="!totalPages || page >= totalPages"
            matTooltip="Nächste Seite"
        >
            <mat-icon>navigate_next</mat-icon>
        </button>
        <button mat-icon-button type="button" (click)="close()" matTooltip="Schließen">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="review-body">
        <div class="pdf-pane" #pdfPane>
            <div class="pdf-loading" *ngIf="pdfLoading && data?.pdfFile">PDF wird geladen …</div>
            <pdf-viewer
                *ngIf="pdfSrc"
                [src]="pdfSrc"
                [page]="page"
                [show-all]="false"
                [render-text]="true"
                [original-size]="false"
                [fit-to-page]="false"
                [autoresize]="true"
                [zoom-scale]="'page-width'"
                (after-load-complete)="onPdfLoad($event)"
                (error)="onPdfError($event)"
            ></pdf-viewer>
            <div class="pdf-missing" *ngIf="!pdfSrc && !pdfLoading">
                <mat-icon>picture_as_pdf</mat-icon>
                <p>{{ data.mode === 'edit' ? 'Kein PDF hinterlegt.' : 'PDF fehlt – Review trotzdem möglich.' }}</p>
            </div>
            <div class="pdf-toolbar" *ngIf="pdfSrc || data?.pdfFile">
                <button
                    mat-stroked-button
                    type="button"
                    (click)="reloadPdf()"
                    [disabled]="!data?.pdfFile || pdfLoading"
                    matTooltip="PDF-Viewer neu laden"
                >
                    <mat-icon>refresh</mat-icon>
                    PDF neu laden
                </button>
                <button
                    mat-stroked-button
                    type="button"
                    color="primary"
                    (click)="openPdfInNewTab()"
                    matTooltip="PDF in neuem Tab öffnen"
                >
                    <mat-icon>open_in_new</mat-icon>
                    PDF öffnen
                </button>
            </div>
        </div>

        <div class="form-pane">
            <p class="meta" *ngIf="data?.draft?.extract?.source">
                Quelle: {{ data.draft.extract.source }}
                <span *ngIf="data.draft.extract.overallConfidence != null">
                    · Confidence {{ (data.draft.extract.overallConfidence * 100) | number: '1.0-0' }}%
                </span>
            </p>
            <p class="meta extract-totals" *ngIf="extractNetto != null || extractBrutto != null">
                Extrakt-Gesamt:
                <span *ngIf="extractNetto != null">Netto {{ extractNetto | number: '1.2-2' }} €</span>
                <span *ngIf="extractNetto != null && extractBrutto != null"> · </span>
                <span *ngIf="extractBrutto != null">Brutto {{ extractBrutto | number: '1.2-2' }} €</span>
            </p>

            <div class="warnings" *ngIf="warnings?.length">
                <div *ngFor="let w of warnings">{{ w }}</div>
            </div>

            <div class="artikel-with-search">
                <kiene-autocomplete
                    (elementSelected)="setLieferant($event)"
                    [apiUrl]="'lieferant/'"
                    [displayField]="'bezeichnung'"
                    [kieneObject]="lieferant"
                    [params]="lieferantParams"
                    [placeholder]="'Lieferant'"
                >
                </kiene-autocomplete>
                <button
                    mat-icon-button
                    type="button"
                    class="artikel-search-btn"
                    (click)="openLieferantPicker()"
                    matTooltip="Nebenkosten-Lieferant suchen / anlegen"
                >
                    <mat-icon>search</mat-icon>
                </button>
            </div>

            <mat-form-field style="width: 100%">
                <mat-label>Kommentar (Kopf)</mat-label>
                <input [formControl]="kommentarCtrl" matInput />
            </mat-form-field>

            <div class="one-row">
                <mat-form-field style="width: 48%">
                    <mat-label>Gutschrift Nr.</mat-label>
                    <input [formControl]="gutschriftNrCtrl" matInput required />
                </mat-form-field>
                <mat-form-field style="width: 48%">
                    <mat-label>Gutschriftdatum</mat-label>
                    <input [formControl]="datumCtrl" [matDatepicker]="picker" matInput required />
                    <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>

            <ng-container *ngIf="nurGesamtbetrag">
                <h3>Gesamtbetrag</h3>
                <p class="hint">
                    Zwei Steuerzeilen auf der Gutschrift? Weitere Position mit anderem MwSt-Satz hinzufügen.
                </p>
                <div class="artikel-with-search gesamt-artikel">
                    <kiene-autocomplete
                        (elementSelected)="setGesamtArtikel($event)"
                        [apiUrl]="'artikel_autocomplete/'"
                        [displayField]="'artikel_me'"
                        [focus]="false"
                        [kieneObject]="gesamtArtikel"
                        [params]="artikelParams"
                        [placeholder]="'Artikel'"
                        [required]="false"
                    >
                    </kiene-autocomplete>
                    <button
                        mat-icon-button
                        type="button"
                        class="artikel-search-btn"
                        (click)="openGesamtArtikelPicker()"
                        matTooltip="Nebenkosten-Artikel suchen / anlegen"
                    >
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
                <mat-form-field style="width: 100%">
                    <mat-label>Leistungsinhalt (Freitext)</mat-label>
                    <input [(ngModel)]="gesamtBezeichnung" matInput placeholder="z.B. Biosicherheitsberatung …" />
                </mat-form-field>
                <mat-form-field class="field-konto" style="width: 100%">
                    <mat-label>Konto</mat-label>
                    <input [value]="gesamtKontoNr || ''" matInput readonly />
                </mat-form-field>
            </ng-container>

            <div class="totals">
                <ng-container *ngIf="nurGesamtbetrag">
                    <div class="preis-row" *ngFor="let p of mwstPositionen; let i = index">
                        <mat-form-field class="field-num-wide">
                            <mat-label>Netto {{ mwstPositionen.length > 1 ? i + 1 : '' }}</mat-label>
                            <input
                                [(ngModel)]="p.kosten_netto"
                                (ngModelChange)="onPositionNettoChanged(p)"
                                matInput
                                kieneDeNumber
                                inputmode="decimal"
                            />
                            <span matSuffix>&euro;</span>
                        </mat-form-field>
                        <mat-form-field class="field-mwst">
                            <mat-label>MwSt</mat-label>
                            <mat-select [(ngModel)]="p.mwstsatz" (ngModelChange)="onPositionMwstChanged(p)">
                                <mat-option *ngFor="let s of mwstSaetze" [value]="s.value">{{ s.label }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button
                            mat-icon-button
                            type="button"
                            class="mwst-calc-btn"
                            (click)="mwstVomBetragAbziehen(p)"
                            [disabled]="!canMwstVomBetragAbziehen(p)"
                            matTooltip="MwSt abziehen (Brutto → Netto)"
                        >
                            <mat-icon>calculate</mat-icon>
                        </button>
                        <mat-form-field class="field-num-wide">
                            <mat-label>MwSt €</mat-label>
                            <input
                                [(ngModel)]="p.mwstEuro"
                                (ngModelChange)="onPositionMwstEuroChanged(p)"
                                matInput
                                kieneDeNumber
                                inputmode="decimal"
                            />
                            <span matSuffix>&euro;</span>
                        </mat-form-field>
                        <button
                            *ngIf="mwstPositionen.length > 1"
                            mat-icon-button
                            type="button"
                            class="pos-delete-btn"
                            (click)="removeMwstPosition(i)"
                            matTooltip="Position entfernen"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                    <div class="one-row pos-add-bottom">
                        <span class="spacer"></span>
                        <button mat-stroked-button type="button" color="accent" (click)="addMwstPosition()">
                            <mat-icon>add</mat-icon>
                            Position hinzufügen
                        </button>
                    </div>
                    <div class="totals-row" *ngIf="mwstPositionen.length > 1">
                        <span>Netto gesamt</span>
                        <span>{{ gesamtNetto | number: '1.2-2' }} €</span>
                    </div>
                    <div class="totals-row totals-brutto brutto-edit-row">
                        <span>Brutto gesamt</span>
                        <div class="brutto-edit">
                            <button
                                mat-icon-button
                                type="button"
                                (click)="adjustBruttoCent(-1)"
                                matTooltip="Brutto −1 Cent (MwSt anpassen)"
                            >
                                <mat-icon>remove</mat-icon>
                            </button>
                            <mat-form-field class="field-brutto">
                                <input
                                    [ngModel]="gesamtBrutto"
                                    (ngModelChange)="onGesamtBruttoChanged($event)"
                                    matInput
                                    kieneDeNumber
                                    inputmode="decimal"
                                />
                                <span matSuffix>&euro;</span>
                            </mat-form-field>
                            <button
                                mat-icon-button
                                type="button"
                                (click)="adjustBruttoCent(1)"
                                matTooltip="Brutto +1 Cent (MwSt anpassen)"
                            >
                                <mat-icon>add</mat-icon>
                            </button>
                            <button
                                *ngIf="extractBrutto != null && bruttoRundungsDiff !== 0"
                                mat-stroked-button
                                type="button"
                                class="brutto-beleg-btn"
                                (click)="applyExtractBrutto()"
                                matTooltip="Brutto vom Beleg übernehmen ({{ extractBrutto | number: '1.2-2' }} €)"
                            >
                                Beleg {{ extractBrutto | number: '1.2-2' }} €
                            </button>
                        </div>
                    </div>
                    <div
                        *ngIf="bruttoRundungsDiff != null && bruttoRundungsDiff !== 0"
                        class="brutto-hint"
                    >
                        Beleg-Brutto weicht um {{ bruttoRundungsDiff | number: '1.2-2' }} € ab – mit ± Cent oder „Beleg“ anpassen.
                    </div>
                </ng-container>
            </div>

            <div class="actions">
                <button
                    (click)="openPrimanotaExportVorschau()"
                    mat-stroked-button
                    type="button"
                    class="vorschau-btn"
                    matTooltip="Primanota-Vorschau Alt (Lieferant) vs Neu (Artikel)"
                >
                    <mat-icon>account_balance</mat-icon>
                    Primanota-Vorschau
                </button>
                <span class="actions-spacer"></span>
                <button mat-button type="button" (click)="close()">Abbrechen</button>
                <button
                    mat-flat-button
                    color="accent"
                    type="button"
                    [disabled]="saving || !isValid()"
                    (click)="save()"
                >
                    Speichern
                </button>
            </div>
        </div>
    </div>
</div>
